<template>
  <div class="main">
    <div class="banner" :style=" 'background-image: url(' + this.banner + ');'">
      <p class="bannerp1">{{bannertext1}}</p>
    </div>
    <div class="timetype">
      <div class="timetypediv1">
        <div class="timestart">
          <el-date-picker
            onfocus="this.blur()"
            v-model="value1"
            disabledDate
            value-format="yyyy-MM-dd"
            type="date"
            clear-icon="none"
            prefix-icon="none"
            style="color:red important;"
            :placeholder="onedata"
          ></el-date-picker>
        </div>
        <div class="timecenter">
          <span>—</span>
        </div>
        <div class="timeend">
          <el-date-picker
            onfocus="this.blur()"
            v-model="value2"
            disabledDate
            value-format="yyyy-MM-dd"
            type="date"
            clear-icon="none"
            prefix-icon="none"
            style="color:#b2b2b2;"
            @blur="changeCount()"
            :placeholder="twodata"
          ></el-date-picker>
        </div>
      </div>
      <div class="timetypediv2">
        <el-dropdown>
          <span class="el-dropdown-link">
            {{this.typennnname}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item  @click.native="getnews()">{{this.typennnname}}</el-dropdown-item> -->
            <el-dropdown-item @click.native="getnewsallin()">{{typennnnamess}}</el-dropdown-item>
            <el-dropdown-item
              @click.native="getnews(item.id,item.type_name,item.type_name_en)"
              v-for="(item,index) in this.typelist"
              :key="index"
            >{{ischinese == "cn" ?item.type_name:item.type_name_en}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="newsCenter">
      <div
        class="father"
        v-for="(item,index) in this.newarray"
        :key="index"
        @click="routerdetails(item.id)"
      >
        <div class="all">
          <p
            class="title"
            style=" -webkit-box-orient: vertical;"
          >{{ischinese == "cn" ?item.title:item.title_en}}</p>
          <p class="time">{{item.time}}</p>
        </div>
      </div>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageSize"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="5"
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template> 
<script>
export default {
  data() {
    return {
      ischinese: "cn",
      banner: "",
      current: 5,
      pageSize: 1,
      total: 0,
      newarray: [],
      typelist: [
        { id: "", type_name: "" },
        { id: "", type_name: "" }
      ],
      value1: "",
      value2: "",
      typeid: "",
      bannertext1: "新闻中心",
      typennnnamess: "全部分类",
      typennnname: "全部分类",
      onedata: "开始日期",
      twodata: "结束日期"
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.typennnname = "All categories";
      this.typennnnamess = "All categories";
      this.onedata = "Start Date";
      this.twodata = "End Date";
      this.bannertext1 = "Information Center";
    }
    this.getCaseModuleList();
  },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页每页每页 ${val} 条`);
      this.current = val;
      this.getCaseModuleList();
    },
    handleCurrentChange(pagesize) {
      // console.log(pagesize);
      this.pageSize = pagesize;
      this.getCaseModuleList();
      document.documentElement.scrollTop = "600";
      document.body.scrollTop = "600";
    },
    routerdetails(detailsid) {
      this.$router.push({
        name: "mDetail",
        query: { detailsid: detailsid }
      });
    },
    getnewsallin() {
      this.typeid = "";
      this.typennnname = "全部分类";
      this.getCaseModuleList();
    },
    getnews(typeid, typename, typename_en) {
      this.typeid = typeid;
      if (this.ischinese == "cn") {
        this.typennnname = typename;
      } else if (this.ischinese == "en") {
        this.typennnname = typename_en;
      }
      this.getCaseModuleList();
    },
    getCaseModuleList() {
      this.$http.post("/api/dashu/news/newTypeList", {}).then(res => {
        if (res.data.code === 0) {
          this.typelist = res.data.data.list;
        }
      });
      this.$http
        .post("/api/dashu/news/newsList", {
          type_id: this.typeid,
          begin_eimt: this.value1,
          end_time: this.value2,
          noPaginate: 1,
          page: this.pageSize,
          pageSize: this.current
        })
        .then(res => {
          if (res.data.code === 0) {
            this.banner = res.data.data.banner.mobile_img;
            const setting = res.data.data;
            this.newarray = setting.lists;
            this.total = setting.total;
            // console.log(this.newarray)
          }
        });
    },
    pageSizeChange(pagesize) {},
    changeCount: function(value) {
      this.getCaseModuleList();
    }
  }
};
</script>
<style scoped>
body {
  position: relative;
}
.banner {
  overflow: hidden !important;
  position: relative;
  overflow: hidden !important;
  position: relative;
  background-size: cover;
  background-position: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 10.29rem;
}
.block {
  overflow: hidden !important;
  position: relative;
  margin: 0.2rem 0.4rem 0.5rem;
  text-align: center;
  height: 0.5rem;
}
.all {
  border-top: 1px solid #b2b2b2;
  padding-top: 0.3rem;
}
.newsCenter {
  overflow: hidden !important;
  position: relative;
  margin: 0 0.4rem 0.5rem;
}
.newsCenter .father:nth-child(1) {
  margin-top: 0px;
}
.newsCenter .title {
  font-size: 0.36rem;
  color: #333;
  font-weight: bold;
  margin: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
}
.newsCenter .time {
  font-size: 0.24rem;
  color: #888888;
  width: 20rem;
}
.el-pagination {
  text-align: center;
  margin-top: 0px !important;
}
.timetype {
  height: 0.4rem;
  padding: 0.9rem 0.4rem 0.6rem;
  position: relative;
}
.timetypediv1 {
  height: 100%;
  position: absolute;
  left: 0.4rem;
  display: flex;
  width: 5rem;
}
.timestart {
  width: 1.6rem;
  color: red !important;
  height: 0.42rem;
  position: absolute;
  top: -40%;
  left: 0;
}
.timecenter {
  font-size: 0.16rem;
  height: 0.42rem;
  line-height: 1.9rem;
  padding: 0 0.1rem;
  color: black !important;
  position: absolute;
  top: -45%;
  left: 34%;
}
.timeend {
  width: 1.6rem;
  height: 0.42rem;
  position: absolute;
  top: -40%;
  left: 42%;
}
.timetypediv2 {
  height: 100%;
  position: absolute;
  top: 9%;
  right: 0.4rem;
}
.el-dropdown-link {
  color: #b2b2b2 !important;
  font-size: 0.22rem;
}
.el-icon-arrow-down {
  font-size: 0.22rem;
  color: #b2b2b2 !important;
}
.bannerp1 {
  /* position: absolute;
  top: 230px;
  left: 400px; */
  text-align: center;
  font-size: 0.8rem;
  font-weight: bold;
  color: white;
  margin-top: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/mbPages/mSchool.vue